module.exports = __webpack_public_path__ + "img/home-05-panoramic-layer-02-long.6307c04b.png";